import React from 'react';
import TwoColumnGrid from './components/TwoColumnGrid/TwoColumnGrid';
import FourColumnGrid from './components/FourColumnGrid/FourColumnGrid';
import { columnAmounts } from './constants/columnAmounts';

const renderContent = ({ columnAmount, ...props }) => {
  switch (columnAmount) {
    case columnAmounts.two:
      return <TwoColumnGrid {...props} />;
    case columnAmounts.four:
      return <FourColumnGrid {...props} />;
    default:
      return null;
  }
};

const Attachment = ({
  className,
  darkBackground = false,
  attachments,
  attachment,
  popConfirmPlacement = 'topRight',
  getAttachmentUrl,
  onDeleteAttachment,
  showMetaData = true,
  ignoreCanBeDeleted = false,
  renderActions,
  renderAdditionalContent,
  columnAmount = columnAmounts.two,
}) => {
  const { canBeDeleted: attachCanBeDeleted } = attachment || {};

  const hasCanBeDeletedKey = 'canBeDeleted' in attachment;

  const canBeDeleted =
    hasCanBeDeletedKey && !ignoreCanBeDeleted
      ? typeof onDeleteAttachment === 'function' && attachCanBeDeleted
      : typeof onDeleteAttachment === 'function';

  const props = {
    className,
    darkBackground,
    attachments,
    attachment,
    popConfirmPlacement,
    getAttachmentUrl,
    onDeleteAttachment,
    showMetaData,
    ignoreCanBeDeleted,
    renderActions,
    renderAdditionalContent,
    columnAmount,
    canBeDeleted,
  };

  return renderContent(props);
};

export default Attachment;
